export default __webpack_public_path__ + "static/media/signal_searching_bhpc.8af6a812.svg";